import CreatableSelect from 'react-select/creatable';
import styled from 'styled-components';

export const PaginatedTableSearchContainer = styled.div`
  z-index: 12;
`;

export const StyledCreatableSelect = styled(CreatableSelect)`
  min-width: 200px;
  max-width: 400px;
  width: 100%;
`;
